
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { SignupFormConfig, SignupFormField } from '@/schemas/signupFormSchema';

interface FormPreviewProps {
  formConfig: SignupFormConfig;
}

const FormPreview: React.FC<FormPreviewProps> = ({ formConfig }) => {
  const renderField = (field: SignupFormField) => {
    if (!field.visible) return null;

    switch (field.type) {
      case 'checkbox':
        return (
          <div className="flex items-center space-x-2 mt-2" key={field.id}>
            <Checkbox id={`preview-${field.id}`} disabled />
            <Label htmlFor={`preview-${field.id}`}>{field.label}</Label>
          </div>
        );
      case 'hidden':
        return null;
      default:
        return (
          <div className="space-y-2 mb-4" key={field.id}>
            <Label htmlFor={`preview-${field.id}`}>{field.label}</Label>
            <Input
              id={`preview-${field.id}`}
              type={field.type}
              placeholder={`Enter ${field.label.toLowerCase()}`}
              disabled
              defaultValue={field.defaultValue}
            />
          </div>
        );
    }
  };

  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Form Preview</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-center mb-6">
          <h2 className="text-xl font-bold">{formConfig.formTitle}</h2>
          <p className="text-sm text-gray-500">This is how your form will appear to users</p>
        </div>

        <div className="p-4 border rounded-md bg-white">
          {formConfig.fields
            .filter(field => field.visible)
            .map(renderField)}

          <div className="mt-6">
            <button 
              className="w-full py-2 px-4 bg-primary text-white rounded disabled:opacity-50" 
              disabled 
            >
              Create Account
            </button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default FormPreview;
